<template>
  <section class="h-100">
    <application-access
      :canRedirectToApplicationAccess="true"
      :siteId="siteId"
      :studyId="studyId"
      :isSummaryPage="true"
      class=""
    ></application-access>
  </section>
</template>

<script>
  import ApplicationAccess from '../../start-up-plan/ApplicationAccess.vue';
  export default {
    name: 'SiteTeamApplicationAccess',
    components: { ApplicationAccess },
    props: {
      studyId: {
        type: String,
      },
      siteId: {
        type: String,
      },
    },
  };
</script>

<style scoped></style>
